module.exports = __webpack_public_path__ + "static/media/android-download.1ef8b32b.png";